import { AuthenticationService } from './../../_services/authentication.service';
import { SolrService } from './../../solr/solr.service';
import { Component, OnInit, } from '@angular/core';
import { Notification } from '../../_models/notification';
import { NotificationsService } from '../../_services/notifications.service';
import { TranslateService } from '@ngx-translate/core';
import { LoggerService } from '../../_services/logger.service';
import { ActivatedRoute, Router } from '@angular/router';
import { RealtimeService } from '../../_services/realtime.service';
import { CommonModule } from '@angular/common';

@Component({
    /* tslint:disable */
    standalone: true,
    selector: '.notificationsBox',
    /* tslint:enable */
    styleUrls: ['./notification-box.component.scss'],
    templateUrl: './notification-box.component.html',
    imports: [CommonModule]
})
export class NotificationBoxComponent implements OnInit {

    public notifications: Notification[] = [];
    notifLength = { 0: 0 };
    dataSolr: any;
    countSigned = 0;
    countNotSinged = 0;
    messageSubscription: any;
    user: any;
    currentUrl: string= '';
    youHaveNotifications;
    notificationsText;
    clearNotifications;
    private deleteResponseSubscription: any = null;
    private notificationSubscription: any = null;

    languageTexts = {
        'en': {
            youHaveNotifications: 'You Have',
            notificationsText: 'notifications',
            clearNotifications: 'Clear Notifications'
        },
        'pt': {
            youHaveNotifications: 'Você tem',
            notificationsText: 'notificações',
            clearNotifications: 'Limpar Notificações'
        },
        'es': {
            youHaveNotifications: 'Tienes',
            notificationsText: 'notificaciones',
            clearNotifications: 'Limpiar notificaciones'
        },
        'fr': {
            youHaveNotifications: 'Vous avez',
            notificationsText: 'notifications',
            clearNotifications: 'Effacer les notifications'
        }
    };

    constructor(
        private notifServ: NotificationsService,
        private logger: LoggerService,
        private solrService: SolrService,
        private authentication: AuthenticationService,
        // private pubnubService: PubnubService, // Removido - substituído por RealtimeService
        private realtimeService: RealtimeService,
        private route: ActivatedRoute,
        private router: Router,
        public translate: TranslateService,

    ) {
        // debugger
        translate.addLangs(['en', 'pt', 'es', 'fr']);
        let storelang = localStorage.getItem("lang") || 'pt';
        this.translate.use(storelang);
        translate.setDefaultLang(storelang);
        this.notifications = [];
        // debugger

        const languageData = (this.languageTexts as any)[storelang];
        this.youHaveNotifications = languageData.youHaveNotifications;
        this.notificationsText = languageData.notificationsText;
        this.clearNotifications = languageData.clearNotifications;



    }

    public ngOnInit() {
        // Every incoming notification changes entire local notification Array.
        this.user = this.authentication.currentUserValue;
        this.notificationSubscription = this.notifServ.notifications.subscribe((notif: Notification[]) => {
            this.logger.log('NotificationBox', '', 'RECEIVED.NOTIFICATION', [])
            this.notifications = notif;
            this.notifLength = { 0: this.notifications.length };
        });
        this.route.queryParams.subscribe((params: any) => {
            const teste = params;
            // console.log('Teste: ', teste);
        });
        this.currentUrl = this.router.url;
        this.loadSubscription();

        this.subscribeGeneral();
    }

    goToRoute(valueRoute: any, id: any) {
        if(valueRoute === 'reload' && this.currentUrl === '/documentos') {
            this.solrService.setCurrentQuery(this.solrService.lastQuery);
        } else if(valueRoute === '/processamentos/error') {
            this.router.navigate([valueRoute]);
        } else {
            this.router.navigate(['/documentos']);
        }
        this.notifServ.removeNotification(id);
    }

    loadSubscription() {
        this.deleteResponseSubscription = this.solrService.deleteSolrDocInCoreAsyncGetResponse().subscribe((data: any) => {
            if(data) {
                this.notifServ.addNotification({ class: 'fa fa-check', link: 'documentos', content: data.message, id: data.id })
            } else {
                this.notifServ.addNotification({ class: 'fa fa-exclamation-triangle', link: 'documentos', content: data.message, id: data.id })
            }
        })
    }

    clearNotifi() {
        this.notifServ.clearNotifications();
    }

    subscribeGeneral() {
        const channels = [];
        if(this.authentication.currentUserValue?.selectedEmpresa) {
            channels.push(this.authentication.currentUserValue.selectedEmpresa._id);
        }

        if(channels.length > 0) {
            if(this.authentication.currentUserValue?.selectedEmpresa && 'useSnsSocketIo' in this.authentication.currentUserValue.selectedEmpresa && this.authentication.currentUserValue.selectedEmpresa.useSnsSocketIo) {
                this.realtimeService.subscribe(channels[0]);
                this.messageSubscription = this.realtimeService.subscribe(channels[0]).subscribe((message: any) => {
                    if (!('signed' in message)) {
                        message.signed = false;
                    }
                    if(!message.valid && message.user_id === this.user?.cognitoId) {
                        if(message.index === 5 && message.status === 'FINALIZADO') {
                            if(this.currentUrl === '/documentos') {
                                // tslint:disable-next-line: max-line-length
                                this.notifServ.addNotification({ class: 'fa fa-check', link: 'reload', content: `${this.translate.instant('SHARED.processed')}: ${message.filename}`, id: message.id });
                            } else {
                                // tslint:disable-next-line: max-line-length
                                this.notifServ.addNotification({ class: 'fa fa-check', link: '/documentos', content: `${this.translate.instant('SHARED.processed')}: ${message.filename}`, id: message.id });
                            }

                        }
                        if(message.status === 'ERROR') {
                            // tslint:disable-next-line: max-line-length
                            this.notifServ.addNotification({ class: 'fa fa-exclamation-triangle', link: '/processamentos/error', content: `${this.translate.instant('SHARED.notProcessed')}: ${message.filename}`, id: message.id });
                        }
                    }
                });
            } else {
                // this.subscribePubnub(channels); // PubNub removido - agora usa apenas RealtimeService
            }
        }
    }

    // Método mantido para compatibilidade mas não mais usado - PubNub foi substituído por RealtimeService
    subscribePubnub(channels: any) {
        // REMOVIDO - PubNub não é mais usado
        // if(this.authService.currentUserValue.masterAdmin) {
        //   this.empresaService.getAll().pipe(take(1)).subscribe((empresas: any) => {
        //     empresas.forEach((element: any) => {
        //       channels.push(element._id.toString());
        //     });
        //     if(channels.length > 0) {
        //       this.pubnubService.subscribe(channels);
        //     }
        //   });
        // } else {
        // this.authService.currentUserValue.empresas.forEach((element: any) => {
        //   channels.push(element._id.toString());
        // });
        // this.pubnubService.subscribe(channels);
        // this.messageSubscription = this.pubnubService.getCurrentMessage().subscribe((message: any) => {
        //     // console.log(message);
        //     if (!('signed' in message)) {
        //         message.signed = false;
        //     }
        //     /*
        //     message = {
        //         id: "passe a key do objeto S3",
        //         filename: "nome do arquivo",
        //         status: "staus do processamento da lambda. Finalizado, Processando, Erro",
        //         index : "indice da tarefa lambda. seguir a ordem das lambdas! Começar com 0 e seguir "
        //         progress: "percentual indicando o progresso do processamento da lambda"
        //     }
        //     */

        //     if(!message.valid && message.user_id === this.user.cognitoId) {
        //         if(message.index === 5 && message.status === 'FINALIZADO') {
        //             if(this.currentUrl === '/documentos') {
        //                 // tslint:disable-next-line: max-line-length
        //                 this.notifServ.addNotification({ class: 'fa fa-check', link: 'reload', content: `${this.translate.instant('SHARED.processed')}: ${message.filename}`, id: message.id });
        //             } else {
        //                 // tslint:disable-next-line: max-line-length
        //                 this.notifServ.addNotification({ class: 'fa fa-check', link: '/documentos', content: `${this.translate.instant('SHARED.processed')}: ${message.filename}`, id: message.id });
        //             }

        //         }
        //         if(message.status === 'ERROR') {
        //             // tslint:disable-next-line: max-line-length
        //             this.notifServ.addNotification({ class: 'fa fa-exclamation-triangle', link: '/processamentos/error', content: `${this.translate.instant('SHARED.notProcessed')}: ${message.filename}`, id: message.id });
        //         }


        //     }
        // });
    }

    ngOnDestroy() {
        if(this.authentication.currentUserValue?.selectedEmpresa) {
            if (('useSnsSocketIo' in this.authentication.currentUserValue.selectedEmpresa) && (this.authentication.currentUserValue.selectedEmpresa.useSnsSocketIo)) {
                if(this.authentication.currentUserValue.selectedEmpresa) {
                  this.realtimeService.unsubscribe(this.authentication.currentUserValue.selectedEmpresa._id);
                }
            } else {
                if(this.messageSubscription) {
                    this.messageSubscription.unsubscribe();
                }
            }
        }
        if(this.deleteResponseSubscription) {
            this.deleteResponseSubscription.unsubscribe();
        }
        if(this.notificationSubscription) {
            this.notificationSubscription.unsubscribe();
        }
    }


}
